import { MDBModal, MDBModalBody, MDBModalContent, MDBModalDialog } from 'mdb-react-ui-kit';
import React from 'react';

import PropTypes from 'prop-types';

import CategoryForm from './CategoryForm';

const CategoryFormModal = ({ firm, firmId,  showCategoryModal, setShowCategoryModal, setCategoryData, categoryToUpdate,  categoryData=[],setActiveTab , updateDomainCategories }) => {
    const baseUrl = process.env.REACT_APP_INVENTORY_URL;
    return (
     
            <MDBModal staticBackdrop={true} closeOnEsc={false}
                animationDirection='right'
                open={showCategoryModal}
                centered={true}
            >
                <MDBModalDialog  >
                <MDBModalContent >
                    <MDBModalBody >
                       <CategoryForm baseUrl={baseUrl}  firm={firm} 
                       firmId={firmId}  
                       prevCategories={categoryData} 
                       showCategoryModal={showCategoryModal} 
                       setShowCategoryModal={setShowCategoryModal}  
                       setCategoryData={setCategoryData} 
                       categoryToUpdate={categoryToUpdate}  
                       setActiveTab={setActiveTab} 
                       updateDomainCategories={updateDomainCategories}
                     
                       />

                    </MDBModalBody>
                </MDBModalContent>
                </MDBModalDialog>
        
            </MDBModal>
        
    );
};
CategoryFormModal.propTypes = {
  
    showCategoryModal: PropTypes.bool.isRequired,
    setShowCategoryModal: PropTypes.func,
    setCategoryData: PropTypes.func.isRequired,
    categoryToUpdate: PropTypes.object,
    categoryData: PropTypes.array,
    firm: PropTypes.string,
    firmId: PropTypes.string,
    setActiveTab: PropTypes.func,
    updateDomainCategories: PropTypes.func,
}
export default CategoryFormModal;
